export default "__VITE_PUBLIC_ASSET__5215cc34__"